import styled from "styled-components/macro";

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  min-width: 800px;
  max-width: 900px;

  @media (max-width: 900px) {
    width: 100%;
    flex-wrap: wrap;
    min-width: unset;
    align-items: center;
    justify-content: center;
  }
`;


export const CloseButton = styled.button`
  border: none;
  padding: 0;
  background-color: transparent;
  float: right;
  cursor: pointer;
  margin: 20px;
`;

export const NftImage = styled.img`
  border-radius: 8px;
  width: 400px;

  @media (max-width: 900px) {
    max-width: 50%;
    width: auto;
  }
`;

export const ModalTitle = styled.h3`
  font-size: 32px;
`;

export const Warning = styled.div`
  font-size: 18px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  margin-top: auto;

  button {
    width: 50%;

    &:hover {
      background-image: url(orange-background.png);
      background-position: center; /* Center the image */
      background-repeat: no-repeat; /* Do not repeat the image */
      background-size: fit;
    }
  }
`;

export const InfoWrapper = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const DismissWrapper = styled.div`
  display: flex;
  gap: 20px;
`;
